module.exports = __webpack_public_path__ + "img/134.987a5f7a.jpg";